import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import axios from "axios";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState, useEffect } from "react";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";

import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import IconButton from "@mui/material/IconButton";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";

function PopAddStop(props) {
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const [isBackdrop, setIsBackdrop] = useState(false);
  const [errors, setErrors] = useState({});
  const { onClose } = props;

  const { enqueueSnackbar } = useSnackbar();

  const createUser = (charger_id, session_id, reason) => {
    const payload = {
      action: "stop",
      chargerId: charger_id,
      payload: {
        sessionId: session_id,
      },
      sessionReason: reason,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_BASEURL + "session/transaction",
      data: payload,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.status) {
          enqueueSnackbar(response.data.message, { variant: "success" });

          window.location.reload();
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar("An error occurred while stopping the charger.", {
          variant: "error",
        });
      });
  };

  const [values, setValues] = useState({
    charger_id: "",
    session_id: "",
    reason: "",
  });
  useEffect(() => {
    if (props.isDialog) {
      // reset form values
      setValues({
        charger_id: "",
        session_id: "",
        reason: "",
      });

      setErrors({});
    }
  }, [props.isDialog]);
  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!values.charger_id || !values.session_id || !values.reason)
      return enqueueSnackbar("Please Fill All The Details !!!", {
        variant: "error",
      });
    if (errors.charger_id || errors.session_id) {
      return enqueueSnackbar("Please fix validation errors", {
        variant: "error",
      });
    }

    createUser(values.charger_id, values.session_id, values.reason);
  };
  const handleClose = () => {
    onClose(false);
  };

  const back = () => {
    setIsBackdrop(false);
    onClose(false);
    props.onStateChange(true);
  };

  const validateAlphaNumericWithLimit = (value, max = 30) => {
    if (value.length > max) {
      return `Maximum ${max} characters allowed`;
    }
    if (!allowOnlyAlphanumericAndSpace(value)) {
      return "Only letters and numbers are allowed";
    }
    return "";
  };


  return (
    <>
      <MDBackdrop isBackdrop={isBackdrop} />
      <Dialog
        open={props.isDialog}
        onClose={handleClose}
        fullWidth={false} //  stop stretching
        PaperProps={{
          sx: {
            width: 1000, //  exact width (adjust if needed)
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
              : {
                theme,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
          }
        >
          <IconButton
            aria-label="delete"
            onClick={back}
            style={darkMode ? { color: "#ffffff" } : theme}
          >
            <ArrowBackIcon />
          </IconButton>
          Stop transaction
          <IconButton
            aria-label="delete"
            onClick={handleClose}
            style={darkMode ? { color: "#ffffff" } : theme}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          style={
            darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme
          }
        >
          <MDBox pt={0} pb={0} px={3}>
            <MDBox pt={0}></MDBox>
            <MDBox p={2} component="form" role="form">
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Charger name / ID"
                  name="charger_id"
                  value={values.charger_id}
                  margin="dense"
                  fullWidth
                  inputProps={{ maxLength: 30 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValues((prev) => ({ ...prev, charger_id: value }));
                    setErrors((prev) => ({
                      ...prev,
                      charger_id: validateAlphaNumericWithLimit(value),
                    }));
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    setErrors((prev) => ({
                      ...prev,
                      charger_id: validateAlphaNumericWithLimit(value),
                    }));
                  }}
                  error={Boolean(errors.charger_id)}
                  helperText={errors.charger_id}
                  FormHelperTextProps={{
                    sx: {
                      color: errors.charger_id ? "#d32f2f" : "text.secondary",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />

              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Session ID"
                  name="session_id"
                  value={values.session_id}
                  margin="dense"
                  fullWidth
                  inputProps={{ maxLength: 30 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValues((prev) => ({ ...prev, session_id: value }));
                    setErrors((prev) => ({
                      ...prev,
                      session_id: validateAlphaNumericWithLimit(value),
                    }));
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    setErrors((prev) => ({
                      ...prev,
                      session_id: validateAlphaNumericWithLimit(value),
                    }));
                  }}
                  error={Boolean(errors.session_id)}
                  helperText={errors.session_id}
                  FormHelperTextProps={{
                    sx: {
                      color: errors.session_id ? "#d32f2f" : "text.secondary",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />

              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Stop reason"
                  value={values.reason}
                  name="reason"
                  multiline
                  rows={5}
                  placeholder="Enter stop reason"
                  margin="dense"
                  fullWidth={true}
                  onChange={handleChange}
                />
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                justifyContent: "space-evenly",
                color: "#ffffff",
              }
              : { theme, justifyContent: "space-evenly" }
          }
        >
          <MDButton
            style={{ width: "87%" }}
            variant="gradient"
            color={sidenavColor}
            onClick={handleSubmit}
            disabled={Boolean(errors.charger_id || errors.session_id)}
          >
            STOP
          </MDButton>

        </DialogActions>
      </Dialog>
    </>
  );
}

export default PopAddStop;
